import { Col, Nav, NavItem, NavLink } from "reactstrap";
import { useState } from "react";
import { useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { chatMenuNavData } from "../../../../Constant";
import ChatMenuTabContent from "./ChatMenuTabContent";

const ChatMenu = () => {
  const { toggleSideBar } = useAppSelector((state) => state.chatData);
  const [activeTab, setActiveTab] = useState(1);

  return (
    <Col className={`chat-menu chat-menu-col ps-xl-0 ${toggleSideBar ? "show" : ""}`}>
      <Nav tabs className="border-tab nav-primary">
        {chatMenuNavData.map((data, index) => (
          <NavItem key={index}>
            <NavLink className={activeTab === index + 1 ? "active" : ""} onClick={() => setActiveTab(index + 1)} style={{ cursor: "pointer" }}>
              {data}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <ChatMenuTabContent activeTab={activeTab} />
    </Col>
  );
};

export default ChatMenu;
